import CustomButton from 'components/atoms/custom-button'
import Footer from 'components/molecules/Footer'
import Header from 'components/molecules/Header'
import React, { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { MdInfo } from 'react-icons/md'
import { Spin } from 'antd'
import useAdvisor from 'hooks/useAdvisor'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useAuth from 'hooks/useAuth'
import { typeUserConst } from 'constant'
import PopupNotification from 'components/organisms/PopupNotification'
import WhatsappButton from 'components/atoms/WhatsappButton'

const ScrollToTop = () => {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [pathname])

  return null
}

const MainLayout = () => {
  const { pathname } = useLocation()
  const { userType } = useAuth()
  const { navigateToProfileAdvisor, isProfileAdvisorNotFilled } = useAdvisor()
  if (userType === typeUserConst.UNDECIDED && !pathname.includes('subscription/payment-success')) {
    return <Navigate to={'/onboarding'} replace={true} />
  }
  // if (userType === undefined && ['/blog', '/knowledge-base'].includes(pathname)) {
  //   return <Navigate to={'/'} replace={true} />
  // }

  return (
    <div className="min-h-screen relative flex-col flex">
      <PopupNotification />
      <ScrollToTop />
      {/* Top Banner */}
      {/* <TopBanner /> */}
      {/* Warning Advisor Profile */}
      {isProfileAdvisorNotFilled() ? (
        <div className="h-[56px] bg-surface-warning-dark w-full flex justify-center items-center py-4 gap-4">
          <MdInfo className="fill-white" size={26} />
          <span className="text-white font-medium text-base">
            Lengkapi Profil Advisor Anda untuk mulai menampilkannya kepada Pembeli & Penjual
            potensial!
          </span>
          <CustomButton
            onClick={navigateToProfileAdvisor}
            className="w-fit h-fit py-1 px-1 text-sm"
            type="plain">
            Lengkapi Profil Anda Sekarang
          </CustomButton>
        </div>
      ) : null}
      <Header />
      <Suspense
        fallback={
          <div
            className="
        flex justify-center items-center flex-col h-screen flex-grow">
            <Spin size="large" spinning={true}></Spin>
          </div>
        }>
        <Outlet />
      </Suspense>
      <WhatsappButton />
      <Footer />
    </div>
  )
}

function TopBanner() {
  return (
    <div className="h-[56px] w-full overflow-hidden whitespace-nowrap flex items-center text-default-white text-sm bg-[linear-gradient(90deg,_#2264DC_0%,_#3F94F2_100%)]">
      <div className="animate-marquee inline-block w-full">
        <p className="text-center w-fit flex gap-2 justify-center items-center ">
          Selamat datang di Mode Preview TOMAZZ - Launching Resmi 2 September - Siap untuk listing
          baru - Tersedia Free Trial (Lihat Harga) - 50+ listing sekarang dalam proses. Reservasi
          Spot Anda Sekarang!
          {/* <span className="font-medium flex items-center gap-2">
            <MdRocketLaunch /> Spesial Preview Tersedia!
          </span>{' '}
          25+ listing siap jual. Coba gratis sebelum launch 2 Sept.{' '}
          <Link
            to={'/pricing'}
            className="text-sm no-underline text-default-white font-medium flex items-center gap-2">
            Klik di sini <FaArrowRightLong />
          </Link> */}
        </p>
      </div>
    </div>
  )
}
export default MainLayout
